import script from "./SubscriptionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionForm.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionForm.vue?vue&type=style&index=0&id=1ce9d4e0&lang=scss"

const __exports__ = script;

export default __exports__